<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "App",
  computed: {
    ...mapGetters(["token"])
  },
  created() {
    if (this.token) {
      //页面刷新后加载路由表
      this.$store.dispatch("permission/getRoutes")
    }
  }
}
</script>
<style lang="scss">
@import "./assets/fonts/fonts.css";
.lower_formitem_box {
  height: 100%;
  .el-form-item {
    margin-bottom: 7px !important;
  }
  h3 {
    margin: 10px 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
}

.statistic_left {
  flex: 1;
  color: #909399;
  text-align: left;
  padding-left: 4px;
  padding-top: 8px;
  font-size: 14px;
  .sbox {
    border: 1px solid #f0f0f0;
    padding: 8px;
    border-radius: 5px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
  }
  .bold {
    color: #333;
  }
  .ssuc {
    color: green;
  }
  .sfail {
    color: red;
  }
  .sinfo {
    color: blue;
  }
  span:not(:first-child) {
    margin-left: 10px;
  }
}
.show_assets_code {
  color: #165dff;
  cursor: pointer;
}
</style>
